@if (!success) {
	<section>
		<div class="row my-4">
			<div class="col-1">
				<img width="27" height="27" alt="aviso negativo" src="/assets/icons/svg/aviso-negativo.svg" loading="lazy" />
			</div>
			<div class="col-11">
				<span> Desafortunadamente, aún no tenemos servicio en tu región. Introduce tu correo y nos pondremos en contacto contigo en cuanto el servicio esté disponible. </span>
			</div>
		</div>
		<form [formGroup]="form" (ngSubmit)="onSubmit()" class="row">
			<div class="col-md-6 col-12">
				<div class="form-group invert-input">
					<label class="form-label" for="name">Nombre</label>
					<input type="text" formControlName="name" id="name" class="form-control form-input" />
				</div>
			</div>
			<div class="col-md-6 col-12">
				<div class="form-group invert-input">
					<label class="form-label" for="email">Correo</label>
					<input type="email" formControlName="email" id="email" class="form-control form-input" />
				</div>
			</div>
			<div class="custom-checkbox w-100">
				<input class="styled-checkbox" id="hasAcceptedNewsletter" type="checkbox" />
				<label for="hasAcceptedNewsletter"><span> Acepto recibir información y promociones de Mobilize Lease&Co, de Mobilize Financial Services, Renault Colombia y sus socios a través de correo electrónico, SMS o correo físico.</span></label>
			</div>
			<div class="d-flex justify-content-center w-100 my-3">
				<button [disabled]="isPending" type="submit" class="btn btn-sm btn-primary">
					{{ isPending ? 'Enviando...' : 'Enviar' }}
				</button>
			</div>
		</form>
	</section>
}
@if (success) {
	<section>
		<div class="row my-4">
			<div class="col-12">
				<span> ¡Contacto guardado con éxito! Cuando servimos en su región, entraremos en contacto! </span>
			</div>
		</div>
	</section>
}
